import React from 'react';
import { Image, Platform, StyleSheet, Text, View } from 'react-native';
import { Button, HelperText } from 'react-native-paper';
import { useMediaQuery } from 'react-responsive';
import * as Device from 'expo-device';
import PropTypes from 'prop-types';

import arequipaLogo from '../assets/img/logos/arequipa-institute-logo.png';
import discoveryLogo from '../assets/img/logos/discovery-park-logo.png';
import unsaLogo from '../assets/img/logos/unsa-logo.png';

function MobileLogos() {
  return (
    <View style={styles.logoView}>
      <View style={styles.logoContainer}>
        <Image
          style={styles.logoMobileTwo}
          source={arequipaLogo}
          resizeMethod="scale"
          resizeMode="center"
        />
        <Image
          style={styles.logoMobileTwo}
          source={unsaLogo}
          resizeMethod="scale"
          resizeMode="center"
        />
      </View>
      <View style={styles.logoContainer}>
        <Image
          style={styles.logoMobileOne}
          source={discoveryLogo}
          resizeMethod="scale"
          resizeMode="center"
        />
      </View>
    </View>
  );
}

function WebLogos() {
  return (
    <View style={styles.logoView}>
      <View style={styles.logoContainer}>
        <Image
          style={styles.logoWebTwo}
          source={unsaLogo}
          resizeMethod="resize"
          resizeMode="contain"
        />
        <Image
          style={styles.logoWebTwo}
          source={arequipaLogo}
          resizeMethod="resize"
          resizeMode="contain"
        />
      </View>
      <View style={styles.logoContainer}>
        <Image
          style={styles.logoWebOne}
          source={discoveryLogo}
          resizeMethod="resize"
          resizeMode="contain"
        />
      </View>
    </View>
  );
}

export default function Welcome({ appStyles, pageContent, stepForward }) {
  const isTabletOrMobileDevice = useMediaQuery({
    maxDeviceWidth: 1224,
  });

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{pageContent[0]}</Text>
      <Text style={styles.content}>{pageContent[1]}</Text>
      <View style={styles.buttonView}>
        <Button
          style={appStyles.button}
          labelStyle={appStyles.labelStyle}
          mode="contained"
          onPress={() => stepForward()}
        >
          {pageContent[2]}
        </Button>
      </View>
      <HelperText style={styles.helperText}>{pageContent[3]}</HelperText>
      {Platform.OS !== 'web' ? (
        <MobileLogos />
      ) : !Device.brand && isTabletOrMobileDevice ? (
        <WebLogos />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  buttonView: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingTop: 15,
  },
  content: {
    fontSize: 16,
    textAlign: 'center',
  },
  helperText: { color: 'rgba(0, 0, 0, 0.6)', textAlign: 'center' },
  logo: {
    marginTop: 15,
    height: 75,
    width: 'auto',
  },
  logoContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
  },
  logoMobileOne: {
    marginTop: 15,
    maxHeight: 75,
    maxWidth: '80%',
  },
  logoMobileTwo: {
    maxHeight: 75,
    maxWidth: '40%',
  },
  logoWebOne: {
    marginTop: 15,
    height: 75,
    width: '80%',
  },
  logoWebTwo: {
    height: 75,
    width: '40%',
  },
  logoView: {
    marginTop: 50,
  },
  title: {
    fontSize: 32,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});

Welcome.propTypes = {
  pageContent: PropTypes.array,
  stepForward: PropTypes.func,
};
